<template>
  <v-form @submit.prevent="checkAccountStatus" v-model="isFormValid">
    <div class="text-h6"
      >Enter your phone number so we can find your account:</div
    >
    <v-text-field
      v-model="phone"
      class="phone-input mt-4"
      color="deep-orange"
      label="Phone Number"
      large
      :rules="[phoneRule]"
      ref="phone"
      autofocus
    />
    <transition name="fade" mode="out-in">
      <div v-if="error" class="red--text mb-2">{{ error }}</div>
    </transition>
    <v-btn
      color="amber darken-3"
      :disabled="!hasValidPhone"
      class="white--text"
      :loading="loading"
      depressed
      block
      x-large
      type="submit"
      >Search</v-btn
    >
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { CustomerRoutes } from '@/constants/RouteNames'

export default {
  name: 'LoginPhoneForm',
  components: {},
  data() {
    return {
      loading: false,
      error: false,
      isFormValid: false,
      LegacyCustomerUpdateRoute: CustomerRoutes.LEGACY_UPDATE,
      LegacyCustomerUpdateNoEmailRoute: CustomerRoutes.LEGACY_UPDATE_NO_EMAIL,
      VerifyPhoneRoute: CustomerRoutes.LOGIN_VERIFY_PHONE,
      phone: '',
      phoneRule: (phone) => {
        if (phone.match(/[^().-\s\d]/)) {
          return 'Please enter numbers only'
        }

        let sanitizedPhone = phone.replace(/\D/g, '')
        if (!phone || !sanitizedPhone) return false

        if (sanitizedPhone[0] === '1') {
          return 'Enter a Valid 10 Digit Phone Number'
        }
        return sanitizedPhone.length === 10 || 'Enter a 10 Digit Phone'
      },
    }
  },
  methods: {
    ...mapActions('customer', ['checkCustomerExists', 'sendCode']),

    async checkAccountStatus() {
      this.loading = true
      this.error = false
      let {
        exists,
        email,
        pass,
        phone_verified,
      } = await this.checkCustomerExists(this.phone)
      this.loading = false
      if (exists) {
        if (!phone_verified) {
          let wasCodeSent = await this.sendUserCode()
          if (wasCodeSent) {
            this.$router.push({
              name: this.VerifyPhoneRoute,
              params: { phone: this.phone },
            })
          } else {
            this.error =
              'We were unable to send a one time code to that number. Please try again.'
          }
        } else if (email && pass) {
          this.$emit('validated', email)
        } else {
          let routeName = email
            ? this.LegacyCustomerUpdateRoute
            : this.LegacyCustomerUpdateNoEmailRoute
          this.$router.push({
            name: routeName,
            params: {
              phone: this.phone,
              ...(email && { emailHint: email }),
            },
          })
        }
      } else {
        this.error = `Sorry we couldn't find an account registered to that number.`
      }
    }, // checkAccountStatus

    async sendUserCode() {
      this.loading = true
      this.error = false
      let wasCodeSent = null
      try {
        wasCodeSent = await this.sendCode(this.phone)
        this.loading = false
        if (wasCodeSent) {
          this.error = false
        }
      } catch (error) {
        this.error = `A new code could not be sent. Please try again.`
      }
      return wasCodeSent
    }, // sendUserCode
  },
  computed: {
    ...mapGetters('customer', ['getCustomerPhone']),
    sanitizedPhone() {
      return this.phone.replace(/\D/g, '')
    }, // sanitizedPhone
    hasValidPhone() {
      return this.sanitizedPhone.length === 10 && this.sanitizedPhone[0] !== '1'
    }, // hasValidPhone
  },
  created() {
    if (this.getCustomerPhone.length) {
      this.phone = this.getCustomerPhone
    }
  },
  mounted() {
    this.$refs.phone.$el.focus()
  },

  beforeDestroy() {
    this.loading = false
    this.error = false
  },
}
</script>
